import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "sm:flex sm:items-center" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, "Create, read, update and delete config items.")
], -1);
const _hoisted_3 = { class: "mt-4 sm:mt-0 sm:ml-16 sm:flex-none" };
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "mt-8 flex flex-col" };
import { ClockIcon, DocumentAddIcon, DocumentTextIcon, FlagIcon, OfficeBuildingIcon, ViewGridAddIcon, ViewGridIcon, } from '@heroicons/vue/solid';
import { computed, markRaw, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import ContractManagement from '@/components/admin/admin-components/config/ContractManagement.vue';
import DivisionManagement from '@/components/admin/admin-components/config/DivisionManagement.vue';
import EntityManagement from '@/components/admin/admin-components/config/EntityManagement.vue';
import KronosManagement from '@/components/admin/admin-components/config/KronosManagement.vue';
import ContractTypeForm from '@/components/admin/admin-components/config/forms/ContractTypeForm.vue';
import DivisionForm from '@/components/admin/admin-components/config/forms/DivisionForm.vue';
import EntityForm from '@/components/admin/admin-components/config/forms/EntityForm.vue';
import KronosFormWrapper from '@/components/admin/admin-components/config/forms/KronosFormWrapper.vue';
import LocationForm from '@/components/admin/admin-components/config/forms/LocationForm.vue';
import LocationManagement from '@/components/admin/admin-components/config/LocationManagement.vue';
import ModalWindow from '@/components/ModalWindow.vue';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfigManagement',
    setup(__props) {
        const store = useStore();
        const configItems = ref({});
        const selectedItem = ref();
        const showModal = ref(false);
        const configItemTypes = markRaw([
            {
                text: 'Contracts',
                component: ContractManagement,
                modalContent: {
                    icon: DocumentAddIcon,
                    editIcon: DocumentTextIcon,
                    title: 'New Contract',
                    editTitle: 'Edit Contract',
                    subtitle: 'Please fill out all the contract details',
                    component: ContractTypeForm,
                },
            },
            {
                text: 'Divisions',
                component: DivisionManagement,
                modalContent: {
                    icon: ViewGridAddIcon,
                    editIcon: ViewGridIcon,
                    title: 'New Division',
                    editTitle: 'Edit Division',
                    subtitle: 'Please fill out all the division details',
                    component: DivisionForm,
                },
            },
            {
                text: 'Entities',
                component: EntityManagement,
                modalContent: {
                    icon: FlagIcon,
                    editIcon: FlagIcon,
                    title: 'New Entity',
                    editTitle: 'Edit Entity',
                    subtitle: 'Please fill out all the entity details',
                    component: EntityForm,
                },
            },
            {
                text: 'Locations',
                component: LocationManagement,
                modalContent: {
                    icon: OfficeBuildingIcon,
                    editIcon: OfficeBuildingIcon,
                    title: 'New Location',
                    editTitle: 'Edit Location',
                    subtitle: 'Please fill out all the location details',
                    component: LocationForm,
                },
            },
            {
                text: 'Kronos',
                component: KronosManagement,
                modalContent: {
                    icon: ClockIcon,
                    editIcon: ClockIcon,
                    title: 'New Region',
                    editTitle: 'Edit Region',
                    subtitle: 'Manage Kronos Region ID, Contract ID and Team ID',
                    component: KronosFormWrapper,
                },
            },
        ]);
        const isKronosSelected = computed(() => currentSelectedType.value?.text === 'Kronos');
        const modalContentSelectedItem = computed(() => {
            if (!isKronosSelected.value || !selectedItem.value)
                return selectedItem.value;
            const item = selectedItem.value;
            if (item?.formType !== undefined)
                return selectedItem.value;
            return { formType: 'kronosRegion', configData: item?.configData ?? item };
        });
        const modalIsEditMode = computed(() => {
            if (!selectedItem.value)
                return false;
            if (!isKronosSelected.value)
                return true;
            const item = selectedItem.value;
            const hasConfigData = item?.configData !== undefined && item?.configData !== null;
            return hasConfigData;
        });
        const kronosModalTitle = computed(() => {
            if (!currentSelectedType.value)
                return '';
            if (!isKronosSelected.value) {
                return modalIsEditMode.value
                    ? currentSelectedType.value.modalContent.editTitle
                    : currentSelectedType.value.modalContent.title;
            }
            const item = selectedItem.value;
            const formType = item?.formType ?? 'kronosRegion';
            const isEdit = item?.configData !== undefined && item?.configData !== null;
            const titles = {
                kronosRegion: { new: 'New Region', edit: 'Edit Region' },
                kronosCode: { new: 'New Code', edit: 'Edit Code' },
                kronosLicense: { new: 'New License', edit: 'Edit License' },
            };
            const t = titles[formType] ?? titles.kronosRegion;
            return isEdit ? t.edit : t.new;
        });
        const kronosModalSubtitle = computed(() => {
            if (!currentSelectedType.value)
                return '';
            if (!isKronosSelected.value)
                return currentSelectedType.value.modalContent.subtitle;
            const item = selectedItem.value;
            const formType = item?.formType ?? 'kronosRegion';
            const subtitles = {
                kronosRegion: 'Manage Kronos Region ID, Contract ID and Team ID',
                kronosCode: 'Manage Kronos Code options for the Amends form',
                kronosLicense: 'Manage Kronos License options for the Amends form',
            };
            return subtitles[formType] ?? subtitles.kronosRegion;
        });
        const selectedConfigItemType = ref('Contracts');
        const currentSelectedType = computed(() => configItemTypes.find((item) => item.text === selectedConfigItemType.value));
        const handleToggleModal = (config) => {
            if (config !== undefined) {
                selectedItem.value =
                    config.formType !== undefined
                        ? { formType: config.formType, configData: config.configData }
                        : config.configData;
            }
            else {
                selectedItem.value = undefined;
            }
            showModal.value = !showModal.value;
        };
        const fetchConfigItems = async () => {
            store.dispatch('setIsLoading', true);
            try {
                const response = await httpClient.post('/config/all', {
                    requestedBy: 'something',
                });
                configItems.value = response.data.body;
            }
            catch (err) {
                console.log(err);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'Could not fetch config items',
                });
            }
            store.dispatch('setIsLoading', false);
        };
        onMounted(async () => {
            store.dispatch('setIsLoading', true);
            await fetchConfigItems();
            store.dispatch('setIsLoading', false);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedConfigItemType).value = $event)),
                            class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(configItemTypes), (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: item.text,
                                    value: item.text
                                }, _toDisplayString(item.text), 9, _hoisted_4));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, selectedConfigItemType.value]
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(currentSelectedType.value.component), {
                        contracts: configItems.value.CONTRACTS,
                        divisions: configItems.value.DIVISIONS,
                        entities: configItems.value.ENTITIES,
                        kronos: configItems.value.KRONOS,
                        "kronos-codes": configItems.value.KRONOS_CODES,
                        "kronos-licenses": configItems.value.KRONOS_LICENSES,
                        locations: configItems.value.LOCATIONS,
                        onOpenModal: handleToggleModal
                    }, null, 40, ["contracts", "divisions", "entities", "kronos", "kronos-codes", "kronos-licenses", "locations"]))
                ]),
                _createTextVNode(),
                (showModal.value)
                    ? (_openBlock(), _createBlock(ModalWindow, {
                        key: 0,
                        size: "5xl",
                        onClose: handleToggleModal
                    }, {
                        icon: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(modalIsEditMode.value ? currentSelectedType.value.modalContent.editIcon || currentSelectedType.value.modalContent.icon : currentSelectedType.value.modalContent.icon), {
                                class: "h-10 w-12 text-green-600",
                                "aria-hidden": "true"
                            }))
                        ]),
                        title: _withCtx(() => [
                            _createTextVNode(_toDisplayString(kronosModalTitle.value), 1)
                        ]),
                        subtitle: _withCtx(() => [
                            _createTextVNode(_toDisplayString(kronosModalSubtitle.value), 1)
                        ]),
                        main: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(currentSelectedType.value.modalContent.component), {
                                "selected-item": modalContentSelectedItem.value,
                                onRefreshConfig: fetchConfigItems,
                                onCloseModal: handleToggleModal
                            }, null, 40, ["selected-item"]))
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
